import { api } from './api'
import { apiRoutes } from 'const/apiRoutes'
import { SupervisorSubordinates } from 'components/private/supervisor/SupervisorSubordinates'

export default {
  getSupervisorSubordinates(): Promise<SupervisorSubordinates[]> {
    return api.get(apiRoutes.getSupervisorSubordinates)
  },
}
